jQuery(function ($) {
	if(typeof window.jspdf === 'undefined') {return;}
	const { jsPDF } = window.jspdf;
	var doc;

	var filename = ''; // The name of your the pdf file
	var $container = $('.certificate-content'); // The div you want to conver to PDF


	const userData = JSON.parse(localStorage.getItem("userProgress"))

	$('.certificate-download').on('click', function (e) {
		var loader = '<img class="loader" src="/wp-content/themes/patientnamnden/build/assets/images/loader.svg" />';
		$(".certificate-container").append(loader);
		filename = 'Intyg';
		e.preventDefault();

		$container.addClass('printing');
		var clone = hiddenClone($container[0]);
		synchronizeCssStyles($container[0], clone, true)
		$container[0].style.opacity = 0.6;
		$(window).scrollTop(0); // You need to scroll top in the window for this to work
		createPDF(clone, function (doc) {
			doc.save(filename + '.pdf');
			$container[0].style.opacity = 1;
			$('.loader').remove();
			$container.removeClass('printing');
		});
	});


	function createPDF(container, callback) {
		getCanvas(container).then(function(canvas) {
			var imgData = canvas.toDataURL("image/png");
			// window.open(imgData);

			doc = new jsPDF( {
				orientation: 'p',
				unit: 'pt',
				format: 'a4'
			});
			// var position = 0;


			doc.addImage(imgData, 'PNG', 0,0, 595, 842);

			$('.certificate-content').last().remove(); //remove the clone
			markCertificateAsDownloaded();
			callback(doc);

		});
	}

	function getCanvas(container) {
		return html2canvas(container, {
			imageTimeout: 0,
			removeContainer: true,
			// logging: true,
			height: container.scrollHeight,
			windowHeight: container.scrollHeight,
			scrollY: 200,
			backgroundColor: null
		});
	}

	function hiddenClone(element){
		// Create clone of element

		var clone = $(element).clone(true, true)[0];

		// Position element relatively within the
		// body but still out of the viewport
		var style = clone.style;
		style.position = 'relative';
		style.top = window.innerHeight + 'px';
		style.left = 0;

		// Append clone to body and return the clone
		document.body.append(clone);
		return clone;
	}

	function synchronizeCssStyles(src, destination, recursively) {

		// if recursively = true, then we assume the src dom structure and destination dom structure are identical (ie: cloneNode was used)

		// window.getComputedStyle vs document.defaultView.getComputedStyle
		// @TBD: also check for compatibility on IE/Edge
		destination.style.cssText = document.defaultView.getComputedStyle(src, "").cssText;

		if (recursively) {
			var vSrcElements = src.getElementsByTagName("*");
			var vDstElements = destination.getElementsByTagName("*");

			for (var i = vSrcElements.length; i--;) {
				var vSrcElement = vSrcElements[i];
				var vDstElement = vDstElements[i];
				vDstElement.style.cssText = document.defaultView.getComputedStyle(vSrcElement, "").cssText;
			}
		}
	}


		// Clone off-screen element

	function markCertificateAsDownloaded() {
		const data = {
			action: "mark_certificate_download",
			userId: userData.userID,

		};

		jQuery.ajax({
			async: false,
			url: ajax.ajaxurl,
			data: data,
			type: "POST",
			success: function(data) {
			}
		});
	}




});
